import { gql } from '@apollo/client';

/**
 * GraphQL query to get standard policies with optional enabled filter
 */
export const GET_STANDARD_POLICIES = gql`
  query StandardPolicies($input: GetStandardPoliciesInput) {
    standardPolicies(input: $input) {
      policies {
        id
        name
        description
        isEnabled
        labels {
          labelId
          severity
          scoreThreshold
        }
        createdBy
        createdAt
        lastModifiedBy
        lastModifiedAt
        scope
        isSystemManaged
      }
    }
  }
`;
